import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionUpdate/details/pageContext';

export function PetitionUpdateErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for PetitionUpdate page (error: ${error})`);
}
